/**
 * Two-sided funnel analytics — provider-agnostic, no-op until a provider is configured.
 *
 * Tracks the loop the raise story depends on: candidate signup → activation, and
 * recruiter search → reveal → (reply/hire). Works with PostHog or Plausible if their
 * snippet/key is present; otherwise it's a safe no-op (logs in dev). No PII in events.
 *
 * Enable PostHog by setting REACT_APP_POSTHOG_KEY (and optional REACT_APP_POSTHOG_HOST),
 * or add the Plausible script to index.html. No vendor lock-in.
 */

export const EVENTS = {
  CANDIDATE_JOIN: 'candidate_join',        // candidate side: signup
  PROFILE_MANAGE: 'profile_manage',        // candidate activation
  POOL_SEARCH: 'pool_search',              // recruiter: search
  CONTACT_REVEAL: 'contact_reveal',        // recruiter: reveal
  REVEAL_LIMIT: 'reveal_limit_hit',        // recruiter: upgrade trigger
  AGENT_MATCH: 'agent_match',              // candidate agent: matched
  AGENT_APPLY: 'agent_apply',              // candidate agent: applied internally
  WAITLIST_JOIN: 'waitlist_join',          // either side: waitlist
  REFERRAL_INVITE: 'referral_invite',      // growth loop
  WIN_SHARE: 'win_share',                  // growth loop
};

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  // Only load PostHog if a key is configured; otherwise stay a no-op.
  if (key && !window.posthog) {
    try {
      const host = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
      /* eslint-disable */
      !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.async=!0,p.src=s.api_host+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys onSessionId".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
      window.posthog.init(key, { api_host: host, capture_pageview: true });
      /* eslint-enable */
    } catch (e) {
      /* ignore */
    }
  }
}

export function track(event, props = {}) {
  try {
    if (typeof window === 'undefined') return;
    if (window.posthog && window.posthog.capture) window.posthog.capture(event, props);
    if (typeof window.plausible === 'function') window.plausible(event, { props });
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.debug('[analytics]', event, props);
    }
  } catch (e) {
    /* never throw from analytics */
  }
}

const analytics = { track, EVENTS, initAnalytics };
export default analytics;
